import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { I18n as I } from 'react-redux-i18n';

import { setCookie } from 'vdlib';
import {
  LANG_COOKIE_NAME,
  LANG_COOKIE_EXPIRE_DAYS,
  MENU_DROPDOWN_NAME,
} from 'lib/Constants';
import Api from 'lib/Api';
import ReduxHelper from 'lib/ReduxHelper';
import AuthHelper from 'lib/AuthHelper';
import Store, { history } from '../Store';
import {
  APP_ACTION_TYPES as AT,
  fetchInitialData,
  toggleHeaderMenu,
} from './App.actions';

export const loginEpic = (action$, store) =>
  action$.ofType(AT.LOGIN).mergeMap(action =>
    Api.login(action.payload)
      .flatMap(content => Store.dispatch(fetchInitialData()))
      .catch(e => {
        return Observable.of(ReduxHelper.createAction(AT.LOGIN_FAIL, null, e));
      })
  );

export const logoutEpic = (action$, store) =>
  action$.ofType(AT.LOGOUT).mergeMap(action => {
    AuthHelper.logout();
    AuthHelper.clearSession();
    history.push({ pathname: '/login' });
    return Observable.empty();
  });

export const changeLanguageEpic = (action$, store) =>
  action$.ofType('@@i18n/SET_LOCALE').mergeMap(action => {
    if (store.getState().app.user == null) return Observable.empty();
    setCookie(LANG_COOKIE_NAME, action.locale, LANG_COOKIE_EXPIRE_DAYS);
    if (action.norequest !== true) Api.changeLanguage(action.locale);
    return Observable.empty();
  });

// hide burger menu on route change, if open
const hideMenuOnLocationChangeEpic = (action$, store) =>
  action$
    .ofType('@@router/LOCATION_CHANGE')
    .mergeMap(action =>
      store.getState().app.menuDropdownOpen === true
        ? Observable.of(toggleHeaderMenu(MENU_DROPDOWN_NAME, false))
        : Observable.empty()
    );

export default combineEpics(
  ...ReduxHelper.createDefaultEpics(
    [AT.INITIAL_DATA_FETCH, Api.getInitialData, { suppressErrorAlert: true }],
    [
      AT.CHANGE_PASSWORD,
      Api.changePassword,
      { successMessage: () => I.t('EPICS_APP_SUCCESFUL_CHANGE_PASSWORD') },
    ],
    [
      AT.RESET_PASSWORD,
      Api.resetPassword,
      { successMessage: I.t('EPICS_APP_SUCCESFUL_RESET_PASSWORD') },
    ]
  ),
  loginEpic,
  logoutEpic,
  changeLanguageEpic,
  hideMenuOnLocationChangeEpic
);
